import { useState, useEffect } from 'react';

const Toggle = ({ toggle, onChange }) => {

    const [isChecked, setIsChecked] = useState(toggle.active)

    const checkHandler = () => {
        const newCheckedState = !isChecked;
        setIsChecked(newCheckedState);
        if (onChange) {
            onChange(toggle.value, newCheckedState);
        }
    };

    useEffect(() => {
        setIsChecked(toggle.active);
    }, [toggle.active]);

    return (
        <div className="toggle-control d-flex flex-row align-items-center">
            <span className="toggle-control-label d-flex align-items-center">
                {toggle.value === 'showEvents' ? (
                    <svg className="toggle-control-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M8 2v4M16 2v4M3 10h18"/><rect width="18" height="18" x="3" y="4" rx="2"/></svg>
                ) : (
                    <svg className="toggle-control-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l2-5h14l2 5M5 13v7h14v-7M9 20v-5h6v5"/><path d="M3 9h18v4a2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-2-2V9Z"/></svg>
                )}
                <span className="switch-label">{toggle.label}</span>
            </span>
            <label className="switch">
                <input
                    type="checkbox"
                    value={toggle.active}
                    checked={isChecked}
                    onChange={checkHandler}
                />
                <span className="slider"></span>
            </label>
        </div>
    );
};

export default Toggle;
